function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Form - ContactNumber component
 * 
 */

import * as React from 'react';
import { IMAGE_PATH_PREFIX } from '../../data/Data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Image extends React.Component {
  render() {
    const source = `${IMAGE_PATH_PREFIX}${this.props.source}`;
    let icon = null;
    switch (true) {
      case this.props.correct === null:
        icon = null;
        break;
      case this.props.correct === false:
        icon = 'xmark';
        break;
      default:
        icon = 'check';
    }
    return /*#__PURE__*/_jsxs("div", {
      className: "image-container",
      children: [/*#__PURE__*/_jsx("img", {
        src: source,
        alt: this.props.title
      }), icon ? /*#__PURE__*/_jsx("div", {
        className: `icon-container ${icon}`,
        children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: icon,
          inverse: true
        })
      }) : null, /*#__PURE__*/_jsx("div", {
        className: "description",
        children: this.props.title
      })]
    });
  }
}
_defineProperty(Image, "defaultProps", {
  correct: true,
  title: 'An image',
  source: 'photo-guideline-correct.png'
});
export default Image;